module.exports = __webpack_public_path__ + "3bf1314bd79feb4398d00f68c149ccae.svg";